import DataTransferUtil from '@/utils/data-transfer.util';

export const PATIENT_TYPE = {
  ALL: 'all',
  NORMAL: 0,
  MYOPIA: 2,
  AMBLYOPIA: 1,
  OTHERS: 3,
};

export const PATIENT_TYPE_TEXT = {
  [PATIENT_TYPE.ALL]: '全部',
  [PATIENT_TYPE.NORMAL]: '尚未近视',
  [PATIENT_TYPE.MYOPIA]: '近视',
  [PATIENT_TYPE.AMBLYOPIA]: '弱视',
  [PATIENT_TYPE.OTHERS]: '其他',
};

export const PATIENT_TYPE_OPTIONS = DataTransferUtil
  .enumTransfer2Options(PATIENT_TYPE_TEXT);

export const CUSTOMER_TYPE = {
  ALL: 'all',
  PERSONAL: 1,
  STORE: 2,
};

export const CUSTOMER_TYPE_TEXT = {
  [CUSTOMER_TYPE.ALL]: '全部',
  0: '未分类',
  [CUSTOMER_TYPE.PERSONAL]: '个人',
  [CUSTOMER_TYPE.STORE]: '门店',
};

export const CUSTOMER_TYPE_OPTIONS = DataTransferUtil
  .enumTransfer2Options(CUSTOMER_TYPE_TEXT);

export const SEX = {
  ALL: 'all',
  FEMALE: 0,
  MALE: 1,
};

export const SEX_TEXT = {
  [SEX.ALL]: '全部',
  [SEX.FEMALE]: '女',
  [SEX.MALE]: '男',
};

export const SEX_OPTIONS = DataTransferUtil
  .enumTransfer2Options(SEX_TEXT);

export const GENETIC_STATUS = {
  ALL: 'all',
  FALSE: 0,
  TRUE: 1,
  NORMAL: 2,
};

export const GENETIC_STATUS_TEXT = {
  [GENETIC_STATUS.ALL]: '全部',
  [GENETIC_STATUS.TRUE]: '是',
  [GENETIC_STATUS.FALSE]: '否',
  [GENETIC_STATUS.NORMAL]: '不清楚',
};

export const GENETIC_STATUS_OPTIONS = DataTransferUtil
  .enumTransfer2Options(GENETIC_STATUS_TEXT);

export const EYES_POSITION = {
  ALL: 'all',
  ESOTROPIA: 0,
  EXOTROPIC: 1,
  NORMAL: 2,
};

export const EYES_POSITION_TEXT = {
  [EYES_POSITION.ALL]: '全部',
  [EYES_POSITION.ESOTROPIA]: '内斜',
  [EYES_POSITION.EXOTROPIC]: '外斜',
  [EYES_POSITION.NORMAL]: '基本正常/不清楚',
};

export const EYES_POSITION_OPTIONS = DataTransferUtil
  .enumTransfer2Options(EYES_POSITION_TEXT);

export const VISUAL_RANGE_OPTIONS = [
  '0',
  '0.1',
  '0.12',
  '0.15',
  '0.2',
  '0.25',
  '0.3',
  '0.4',
  '0.5',
  '0.6',
  '0.8',
  '1.0',
  '1.2',
  '1.5',
  '2.0',
].map((v) => ({ label: v, value: v }));

const PATIENT_DEMAND_OPTIONS = [
  '想预防近视',
  '假性近视',
  '想控制近视',
  '长时间看近疲劳/调节不足',
  '老花或早老花',
  '调节紧张/过度/看远不能放松',
  '注意力不集中/学习不集中/手眼协调能力差',
  '想做近视术前训练',
  '近视术后调节异常',
  '近视术后存在复视',
  '视力较差',
  '经常眯眼',
  '畏光',
  '视疲劳',
  '注意力不集中/学习不集中',
  '手眼协调能力差',
  '阅读障碍/读书写字慢',
  '长时间看近疲劳',
]
  .map((t) => ({ label: t, value: t }));

PATIENT_DEMAND_OPTIONS.unshift({ label: '全部', value: 'all' });

export { PATIENT_DEMAND_OPTIONS };

export const ALLOWED_PERMISSION = {
  LOG: 'stat:patient:log',
};

export const PATIENT_ACTION = {
  ...ALLOWED_PERMISSION,
};

export const PATIENT_COLUMNS = [
  {
    title: '姓名',
    key: 'nick_name',
    width: 180,
  },
  {
    title: '性别',
    key: 'sex',
    slot: 'sex',
    width: 80,
  },
  {
    title: '年龄',
    key: 'age',
    width: 80,
  },
  {
    title: '患者类型',
    key: 'patient_type',
    slot: 'patientType',
    width: 100,
  },
  {
    title: '联系方式',
    key: 'mobile',
    width: 160,
  },
  {
    title: '用户ID',
    key: 'nick_id',
    width: 120,
  },
  {
    title: '账号类型',
    key: 'type',
    slot: 'type',
    width: 100,
  },
  {
    title: '裸眼视力R/L',
    key: 'naked_eye_vision',
    width: 160,
  },
  {
    title: '矫正视力R/L',
    key: 'corrected_eye_vision',
    slot: 'corrected_eye_vision',
    width: 160,
  },
  {
    title: '球镜度R/L',
    key: 'diop',
    slot: 'diop',
    width: 160,
  },
  {
    title: '眼轴R/L',
    key: 'axial',
    slot: 'axial',
    width: 160,
  },
  {
    title: '柱镜度R/L',
    key: 'cylAxis',
    slot: 'cylAxis',
    width: 160,
  },
  {
    title: '瞳距',
    key: 'pupilDistance',
    slot: 'pupilDistance',
    width: 160,
  },
  {
    title: '遗传史',
    key: 'is_genetic',
    slot: 'geneticStatus',
    width: 100,
  },
  {
    title: '眼位',
    key: 'eye_position',
    slot: 'eyesPosition',
    width: 100,
  },
  {
    title: '患者诉求',
    key: 'self_describe',
    slot: 'patientDemand',
    minWidth: 100,
  },
  {
    title: '治疗史',
    key: 'cure_history',
    slot: 'treatmentHistory',
    minWidth: 100,
  },
  {
    title: '操作',
    slot: 'action',
    width: 100,
    align: 'center',
    fixed: 'right',
  },
];
